// extracted by mini-css-extract-plugin
export var newContentVideoModal = "VideoModal-module--newContentVideoModal--AwVYl";
export var newVideoModalClose = "VideoModal-module--newVideoModalClose--Fnak-";